import { GoogleMeetEvaluationStatus } from '@airreading/common/data';

export const GoogleMeetEvaluationStatusColorMap: Record<GoogleMeetEvaluationStatus, string> = {
  [GoogleMeetEvaluationStatus.send_message]: 'text-lime-700',
  [GoogleMeetEvaluationStatus.no_action_needed]: 'text-[#8E8E93]',
};
